"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AkordError = void 0;
const logger_1 = require("../logger");
class AkordError extends Error {
    constructor(message, error) {
        var _a, _b;
        super(message);
        this.requestId = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b['request-id'];
        logger_1.Logger.log(error);
    }
}
exports.AkordError = AkordError;
